export default {
  cdn: '',
  fbQuote: 'To be updated',
  fbHashtag: '#ToBeUpdated',
}
